import {Observable} from 'rxjs';
import {educatAPI, RestQueryParams} from 'educat-common-web';


export function updateUserAPI(authToken: string, userId: string, payload: any): Observable<any> {
    return educatAPI.put(
        `users/${userId}`,
        payload,
        new RestQueryParams(),
        {
            Authorization: `Bearer ${authToken}`
        }
    );
}
